import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconCheckTick = props => {
  const $ = _c(5);
  const color = props.color || "#424242";
  let t0;
  if ($[0] !== color) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M15.9962 15.9956C18.0124 13.9786 18.8559 11.1287 18.3246 8.37956L19.6746 8.11864C20.2916 11.3113 19.3111 14.6243 16.9685 16.9678C13.1205 20.8159 6.8809 20.8159 3.03186 16.9678C-0.816212 13.1198 -0.816212 6.88012 3.03192 3.03199C6.8809 -0.816011 13.1205 -0.816011 16.9685 3.03205L15.9963 4.00432C12.6852 0.693211 7.31608 0.693211 4.00413 4.00432C0.693031 7.31542 0.693031 12.6845 4.00407 15.9955C7.31608 19.3067 12.6852 19.3067 15.9962 15.9956ZM4.77193 9.91401L5.75087 8.94846L9.3012 12.548L19.3213 2.61791L20.2892 3.59456L9.77959 14.0097C9.50944 14.2774 9.07326 14.275 8.80618 14.0042L4.77193 9.91401Z" fill={color} />;
    $[0] = color;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props || $[3] !== t0) {
    t1 = <svg width={21} height={20} viewBox="0 0 21 20" {...props}>{t0}</svg>;
    $[2] = props;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
IconCheckTick.propTypes = {
  color: PropTypes.string
};
export default IconCheckTick;